// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"as","shareText":"at","show":"au"};